import { isProd } from '@m/config/FeatureFlags';

const SESSION_KEY = 'qa_expressOnboarding';
const VALID_VALUES = ['treatment', 'control'] as const;
type OverrideValue = (typeof VALID_VALUES)[number];

/** Call once on app load to capture ?expressOnboarding=<value> into sessionStorage. */
export function captureQAOnboardingOverride(search: string): void {
  if (isProd) return;
  const value = new URLSearchParams(search).get('expressOnboarding');
  if (value && (VALID_VALUES as readonly string[]).includes(value)) {
    sessionStorage.setItem(SESSION_KEY, value);
  }
}

/** Returns the QA override if present and not in prod, otherwise null. */
export function getQAOnboardingOverride(): OverrideValue | null {
  if (isProd) return null;
  const stored = sessionStorage.getItem(SESSION_KEY);
  return (VALID_VALUES as readonly string[]).includes(stored ?? '')
    ? (stored as OverrideValue)
    : null;
}
